// extracted by mini-css-extract-plugin
module.exports = {"share":"Share-module--share--2xYyC"};